import { Preloader_Container, Preloader_Spinner, Preloader_Text } from "./Preloader.styled";

interface PreloaderProps {
	text?: string;
}

export const Preloader = ({ text = "Loading..." }: PreloaderProps) => {
	return (
		<Preloader_Container
			initial={{ opacity: 0, scale: 0.9, y: 10 }}
			animate={{ opacity: 1, scale: 1, y: 0 }}
			exit={{ opacity: 0, scale: 0.9, y: 10 }}
			transition={{ duration: 0.25, ease: "easeOut" }}
		>
			<Preloader_Spinner
				animate={{ rotate: 360 }}
				transition={{
					duration: 0.8,
					repeat: Infinity,
					ease: "linear",
				}}
			/>
			<Preloader_Text>{text}</Preloader_Text>
		</Preloader_Container>
	);
};
